export const SITE_CONFIG = {
  name: "Patinete Eléctrico Segunda Mano",
  alternateName: "PatineteSegundaMano",
  description: "Marketplace líder de patinetes eléctricos en España. Compra y vende nuevos y de segunda mano de forma segura y al mejor precio.",
  url: "https://patineteelectricosegundamano.com",
  logo: "https://patineteelectricosegundamano.com/og-image.jpg",
  areaServed: "ES",
  contactEmail: "hola@patinetes-segundamano.es",
  contactPhone: "+34 900 000 000",
  socials: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
    youtube: "https://youtube.com",
  }
};
